import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
import ChildTabViewModel from "./../../../factories/child-tab-view-model";
import "./../../../bindings/bao-toolbar2";
import "./../../../bindings/sorting";
function UserProfileTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(this, tabPage, parent);
    self.CompleteCheck = function () {
        return true;
    };
    self.SelectedUserId = ko.observable();
    self.SelectedUserProfile = ko.observable();
    self.ToolbarButtons = ko.observableArray();
    self.ToolbarButtons.subscribe(function () {
        self.EnableToolbarButtons();
    });
    self.User = parent;
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGridUserProfile();
    });
    self.PageSize.subscribe(function () {
        self.RefreshGridUserProfile();
    });
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGridUserProfile();
    });
    self.UserProfileCollection = ko.observableArray([]);
    self.SelectedUserProfileRow = ko.observable({});
    var _deleteMessageUserProfile = Bao.Session.GetMessage("msgDeleteUserProfile");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "UserProfileAdd":
                self.ShowUserProfileDialog(self.User.UserId(), null, true);
                break;
            case "UserProfileEdit":
                if (self.SelectedUserProfileRow() != null) {
                    self.ShowUserProfileDialog(self.User.UserId(), self.SelectedUserProfileRow().UserProfile, false);
                }
                break;
            case "UserProfileDelete":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageUserProfile, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteUserProfile(self.SelectedUserProfileRow().UserProfile);
                    }
                });
                break;
        }
    };
    self.RefreshGridUserProfile = function () {
        tabPage.IsLoading(true);

        // Check if the current page's data exceeds the total rows
        if (this.PageSize() * (this.PageIndex() + 1) > self.TotalRows()) {
            // If so, calculate the new page index
            let newPageIndex = Math.ceil(self.TotalRows() / this.PageSize()) - 1;

            // if we end up on a negative page, set it to 0
            if (newPageIndex < 0) {
                newPageIndex = 0;
            }

            this.PageIndex(newPageIndex);
        }

        return Bao.post("Uadm/UserTab/GetUserProfileCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: self.User.UserId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedUserProfileRow(null);
            self.TotalRows(0);
            self.UserProfileCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.UserProfileCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddUserProfile = function (model, userId) {
        tabPage.IsLoading(true);
        Bao.post("Uadm/UserTab/AddUserProfile", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            model: ko.toJS(model),
            userId: userId
        }), function () {
            self.User.TabPage.DirtyFlag(true);
            self.RefreshGridUserProfile();
        });
    };
    self.DeleteUserProfile = function (userProfile) {
        return Bao.post("Uadm/UserTab/DeleteUserProfile", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userProfile: userProfile
        }), function () {
            self.User.TabPage.DirtyFlag(true);
            self.RefreshGridUserProfile();
        });
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("800px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                var shouldReturn = false;
                if (self.Dialog.ViewModel().IsNewUserProfile()) {
                    $.each(self.UserProfileCollection(), function (index, item) {
                        if (item.UserProfile == self.Dialog.ViewModel().UserProfile()) {
                            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("ProfileNameExists"), "info");
                            shouldReturn = true;
                        }
                    });
                }
                if (shouldReturn) {
                    return;
                }
                if (!Bao.Utils.String.IsNullOrEmpty(self.Dialog.ViewModel().UserProfile())) {
                    self.Dialog.IsLoading(true);
                    self.AddUserProfile(self.Dialog.ViewModel(), self.User.UserId());
                    self.Dialog.Close();
                    self.Dialog.IsLoading(false);
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowUserProfileDialog = function (userId, userProfile, isNew) {
        return Bao.post("Uadm/UserTab/ShowUserProfileDialog", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            userId: userId,
            userProfile: userProfile,
            isNew: isNew
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.SelectedUserProfile.subscribe(function () {
        if (self.SelectedUserProfile() != null) {
            var myModel = {
                UserId: self.SelectedUserProfile().UserId,
                UserProfile: self.SelectedUserProfile().UserProfile,
                UserProfileValue: self.SelectedUserProfile().UserProfileValue,
                IsInherited: false
            };
            self.AddUserProfile(myModel, self.User.UserId());
        }
    });
    self.SelectedUserProfileRow.subscribe(function () {
        self.EnableToolbarButtons();
    });
    self.EnableToolbarButtons = function () {
        $.each(self.ToolbarButtons(), function (index, item) {
            if (item.ActionKey() == "UserProfileDelete" || item.ActionKey() == "UserProfileEdit") {
                if (self.SelectedUserProfileRow() != null && (self.SelectedUserProfileRow().IsInherited == null || self.SelectedUserProfileRow().IsInherited == false)) {
                    item.Enabled(true);
                }
                else {
                    item.Enabled(false);
                }
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("Uadm/UserTab/ResetUserProfile", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId
        }), function () {
            self.RefreshGridUserProfile().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function (savetime) {
        return Bao.post("Uadm/UserTab/SaveUserProfileCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            roleId: self.User.UserId(),
            saveTime: savetime
        }));
    };
    self.Copy = function (userId, saveTime) {
        return Bao.post("Uadm/UserTab/CopyUserProfileCollection", JSON.stringify({
            sessionTabId: self.User.TabPage.SessionTabId,
            roleId: self.User.UserId(),
            newUserId: userId,
            saveTime: saveTime
        }));
    };
    self.loaded = function () {
        self.RefreshGridUserProfile();
    };
}
export default UserProfileTabModel;